export const COMMON_DROPDOWN_MQL = 'acknowledged=0 suppressed=0 severityId<6';
